import React from "react";
import { BrowserRouter } from "react-router-dom";
import Routers from "./routers/router";
import AutoSrcollToTop from "./components/AutoSrcollToTop";
import PopperContact from "./components/PopperContact";

const App = () => {
  return (
    <BrowserRouter>
      <AutoSrcollToTop>
        <PopperContact>
          <Routers />
        </PopperContact>
      </AutoSrcollToTop>
    </BrowserRouter>
  );
};

export default App;
